import { HttpClient } from "@angular/common/http";
import {
  ChangeDetectorRef,
  Component,
  Inject,
  OnChanges,
  OnInit,
} from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  FormControl,
} from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
@Component({
    selector: "app-configure-series",
    templateUrl: "./configure-series.component.html",
    styleUrls: ["./configure-series.component.scss"],
    standalone: false
})
export class ConfigureSeriesComponent implements OnInit, OnChanges {
  public editForm!: UntypedFormGroup;
  field: any;
  currentDataFields: any;

  fieldsHidden: boolean = false;
  message: string = "Are you sure?";
  private dataPointId!: number;
  name: string = "";
  constructor(
    private fb: UntypedFormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private http: HttpClient,
    private cdRef: ChangeDetectorRef,
    private dialogRef: MatDialogRef<ConfigureSeriesComponent>
  ) {
    this.editForm = this.fb.group({
      breakDownDataPointId: new FormControl(0),
    });
    if (data) {
      this.message = data.message || this.message;
      this.dataPointId = data.id;
      this.field = data.field;
      this.name = data.name;
      this.currentDataFields = data.currentDataFields;
      if (this.field.breakDownDataPointId)
        this.editForm
          .get("breakDownDataPointId")
          ?.setValue(this.field.breakDownDataPointId);
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onConfirmClick(): void {
    if (this.editForm.valid) {
      const breakDownDataPointId = this.editForm.get(
        "breakDownDataPointId"
      )!.value;
      this.field.breakDownDataPointId = breakDownDataPointId;
      this.dialogRef.close(this.field);
    }
  }

  onCancelClick(): void {
    this.dialogRef.close(null);
  }

  ngOnChanges() {
    this.cdRef.markForCheck();
    this.cdRef.detectChanges();
  }

  ngOnInit(): void {}
}
